import { isIOS } from "./isIOS";

const DELAY_DOWNLOAD_TIME = 7000;

export const downloadBlobFile = (blob: Blob, name: string) => {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = name;

    link.setAttribute('target', isIOS ? '_self' : '_blank');

    link.click();
    link.remove();
    setTimeout(() => URL.revokeObjectURL(link.href), DELAY_DOWNLOAD_TIME);
};